exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-link[data-v-5de607cc]{border:none}.text-link[data-v-5de607cc]{font-size:12px}", ""]);

// exports
